import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import API from '../api';
import { useLang, LangToggle } from '../i18n';

const MEDAL = ['#F5C518','#B0B8C1','#CD7F32'];

export default function Leaderboard() {
  const [tab, setTab]     = useState('day');
  const [list, setList]   = useState([]);
  const [loading, setL]   = useState(true);
  const nav = useNavigate();
  const { t, lang } = useLang();

  const TABS = [
    { key:'day',    label: lang==='en'?'Today':'日榜' },
    { key:'week',   label: lang==='en'?'Weekly':'周榜' },
    { key:'season', label: lang==='en'?'Season':'赛季榜' },
    { key:'best',   label: lang==='en'?'Best Trader':'最强交易员' },
  ];

  useEffect(() => {
    setL(true);
    API.get(`/api/game/leaderboard?type=${tab}`)
      .then(r => setList(r.list || []))
      .catch(() => setList([]))
      .finally(() => setL(false));
  }, [tab]);

  const isBest = tab === 'best';

  const S = `
    .lb-root{min-height:100vh;min-height:100dvh;
      background:linear-gradient(180deg,#0B1E4A 0%,#0D2B6B 50%,#091840 100%);
      background-attachment:fixed;padding-bottom:40px;}
    .lb-header{display:flex;align-items:center;justify-content:space-between;
      padding:52px 20px 20px;border-bottom:1px solid rgba(46,127,232,0.2);}
    .lb-title{font-size:22px;font-weight:900;color:#fff;letter-spacing:0.5px;}
    .lb-back{padding:8px 16px;border-radius:10px;border:1px solid rgba(46,127,232,0.35);
      background:rgba(46,127,232,0.1);color:#8BA8D4;font-size:13px;font-weight:600;cursor:pointer;}
    .lb-tabs{display:flex;gap:6px;padding:16px 16px 0;overflow-x:auto;-webkit-overflow-scrolling:touch;scrollbar-width:none;}
    .lb-tabs::-webkit-scrollbar{display:none;}
    .lb-tab{padding:9px 16px;border-radius:10px;border:none;font-size:13px;font-weight:700;
      cursor:pointer;transition:all 0.15s;white-space:nowrap;flex-shrink:0;}
    .lb-tab.active{background:linear-gradient(180deg,#FFD700 0%,#E6A800 100%);color:#000;
      box-shadow:0 3px 0 #8B6200;}
    .lb-tab.active-best{background:linear-gradient(180deg,#FF6B35 0%,#E8453C 100%);color:#fff;
      box-shadow:0 3px 0 #8B1F1A;}
    .lb-tab.inactive{background:rgba(46,127,232,0.12);color:#8BA8D4;
      border:1px solid rgba(46,127,232,0.25);}
    .lb-best-banner{margin:16px 16px 0;padding:10px 16px;
      display:flex;align-items:center;gap:10px;}
    .lb-best-icon{display:none;}
    .lb-best-desc{font-size:12px;color:#fff;line-height:1.5;}
    .lb-best-desc strong{color:#fff;font-size:13px;}
    .lb-list{padding:12px 16px;display:flex;flex-direction:column;gap:8px;}
    .lb-row{display:flex;align-items:center;gap:12px;padding:13px 14px;border-radius:14px;
      background:#0F2554;}
    .lb-row.top1{background:rgba(245,197,24,0.08);}
    .lb-row.top2{background:rgba(176,184,193,0.06);}
    .lb-row.top3{background:rgba(205,127,50,0.06);}
    .lb-row.best-top1{background:rgba(255,107,53,0.10);}
    .lb-row.best-top2{background:rgba(255,159,90,0.07);}
    .lb-row.best-top3{background:rgba(255,208,128,0.06);}
    .lb-rank{width:34px;height:34px;border-radius:50%;display:flex;align-items:center;
      justify-content:center;font-size:15px;font-weight:900;flex-shrink:0;}
    .lb-name{flex:1;font-size:15px;font-weight:700;color:#fff;
      white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
    .lb-pts{font-family:'Share Tech Mono',monospace;font-size:19px;font-weight:700;white-space:nowrap;}
    .lb-empty{text-align:center;color:#4A6A9A;padding:60px 0;font-size:14px;}
  `;

  const BEST_MEDAL = ['#FF6B35','#FF9F5A','#FFD080'];

  function rowClass(i) {
    if (isBest) return i===0?'best-top1':i===1?'best-top2':i===2?'best-top3':'';
    return i===0?'top1':i===1?'top2':i===2?'top3':'';
  }

  function rankStyle(i) {
    const colors = isBest ? BEST_MEDAL : MEDAL;
    if (i < 3) return {
      background: `linear-gradient(180deg,${colors[i]}dd 0%,${colors[i]}88 100%)`,
      color: isBest ? '#fff' : '#000',
      boxShadow: `0 2px 0 ${colors[i]}66`,
    };
    return { background:'rgba(46,127,232,0.15)', color:'#4A6A9A' };
  }

  function ptsColor(i) {
    if (isBest) return i===0?'#FF6B35':i===1?'#FF9F5A':i===2?'#FFD080':'#8BA8D4';
    return i===0?'#F5C518':i===1?'#B0B8C1':i===2?'#CD7F32':'#8BA8D4';
  }

  function ptsLabel(u) {
    if (isBest) return `${Number(u.single_pts).toLocaleString()} PTS`;
    return `+${Number(u.total_points).toLocaleString()}`;
  }

  return (
    <div className="lb-root">
      <style>{S}</style>

      <div className="lb-header">
        <div className="lb-title">{isBest ? (lang==='en'?'Best Trader':'最强交易员') : t('leaderboardTitle')}</div>
        <div style={{display:'flex',alignItems:'center',gap:8}}>
          <LangToggle />
          <button className="lb-back" onClick={() => nav('/lobby')}>{lang==='en'?'← Back':'← 返回大厅'}</button>
        </div>
      </div>

      <div className="lb-tabs">
        {TABS.map(tb => {
          let cls = 'inactive';
          if (tab === tb.key) cls = tb.key === 'best' ? 'active-best' : 'active';
          return (
            <button key={tb.key} className={`lb-tab ${cls}`} onClick={() => setTab(tb.key)}>
              {tb.label}
            </button>
          );
        })}
      </div>

      {isBest && (
        <div className="lb-best-banner">
          <div className="lb-best-icon"></div>
          <div className="lb-best-desc">
            <strong>{lang==='en'?'Best Single Round PTS':'单局最高 PTS 记录'}</strong><br/>
            {lang==='en'?'Top 100 traders by best single round performance':'展示历史所有对局中单场表现最强的前 100 名交易员'}
          </div>
        </div>
      )}

      <div className="lb-list">
        {loading ? (
          <div className="lb-empty">{t('loading')}</div>
        ) : list.length === 0 ? (
          <div className="lb-empty">{lang==='en'?'No data yet. Go battle!':'暂无数据，快去对局创造记录！'}</div>
        ) : list.map((u, i) => (
          <div key={`${u.id}-${i}`} className={`lb-row ${rowClass(i)}`}>
            <div className="lb-rank" style={rankStyle(i)}>{i + 1}</div>
            <div className="lb-name">{u.nickname || `${lang==='en'?'Player':'玩家'}${u.id}`}</div>
            <div className="lb-pts" style={{ color: ptsColor(i) }}>
              {ptsLabel(u)}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
